import { render, staticRenderFns } from "./BinImportModal.vue?vue&type=template&id=5a53add9"
import script from "./BinImportModal.vue?vue&type=script&lang=ts"
export * from "./BinImportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports